<mat-card
	mat-dialog-content
	class="sdp-confirmation-dialog-container"
>
	<h3 class="sdp-confirmation-dialog-header">{{ title | translate }}</h3>
	<div
		class="sdp-confirmation-dialog-message"
		[innerHTML]="message"
	></div>
	<div
		*ngIf="confirmationMessage"
		class="sdp-confirmation-dialog-confirmation"
	>
		<mat-divider></mat-divider>
		<div class="sdp-confirmation-dialog-warning">{{ confirmationMessage | translate }}</div>
		<mat-form-field class="sdp-confirmation-dialog-value">
			<input
				matInput
				placeholder="{{ confirmationPlaceholder | translate }}"
				type="text"
				[(ngModel)]="confirmationValue"
			>
		</mat-form-field>
	</div>
	<div class="sdp-form-buttons-container sdp-confirmation-dialog-splitter">
		<button
			class="sdp-button-small-text"
			type="button"
			color="primary"
			mat-button
			(click)="deleteAction(false)"
		>{{ buttonCancel | translate }}</button>
		<button
			type="button"
			color="primary"
			mat-raised-button
			[disabled]="!!confirmationMessage && !confirmValue(confirmationValue)"
			(click)="deleteAction(true)"
		>{{ buttonAction | translate }}</button>
	</div>
</mat-card>